// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1QNgN","errorLogs":"styles_errorLogs__111HI"};